import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Nav from "../TopNav/TopNav";
import SearchBar from "../SearchBar/SearchBar";

import {
    Box,
    IconButton,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
    Collapse,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";

import Logo from "../../assets/LOGO.png";

import "./Header.css";

import {
    getActiveCategoriesWithSubcategories
} from "../../redux/actions/categoryActions";


const Header = () => {


    const dispatch = useDispatch();


    const [drawerOpen, setDrawerOpen] = useState(false);

    const [activeDropdown, setActiveDropdown] = useState(null);

    const [searchOpen, setSearchOpen] = useState(false);

    const [openParent, setOpenParent] = useState(null);



    const {
        categories = []
    } = useSelector(
        state => state.categoriesState
    );


    const {
        cartItems = []
    } = useSelector(
        state => state.cartState
    );



    useEffect(() => {

        dispatch(
            getActiveCategoriesWithSubcategories()
        );

    }, [dispatch]);





    return (

        <header className="section-header sticky-top">


            <Nav />


            <div className="header-border">

                <div className="container">


                    <div className="header-main">



                        {/* MOBILE MENU */}

                        <div className="mobile-left d-md-none">

                            <IconButton
                                onClick={() => setDrawerOpen(true)}
                            >

                                <MenuIcon />

                            </IconButton>

                        </div>





                        {/* LOGO */}
<div className="header-logo">

                <Link to="/">

                    <img
                        src={Logo}
                        alt="Eternica Beauty"
                        className="logo-img"
                    />

                </Link>

            </div>


                        {/* DESKTOP NAV */}

                        <div className="desktop-navigation d-none d-md-flex">


                            {
                                searchOpen ?

                                    <div className="search-wrapper">


                                        <SearchBar width="500px" />


                                        <IconButton
                                            onClick={() => setSearchOpen(false)}
                                        >

                                            <CloseIcon />

                                        </IconButton>


                                    </div>


                                    :


                                    <ul className="desktop-nav">


                                        {
                                            categories.map((category, index) => {


                                                const hasSub =
                                                    category.subcategories?.length > 0;



                                                return (

                                                    <li

                                                        key={category._id}

                                                        className="nav-category"

                                                        onMouseEnter={() => {

                                                            if (hasSub)
                                                                setActiveDropdown(index)

                                                        }}

                                                        onMouseLeave={() => setActiveDropdown(null)}

                                                    >


                                                        <Link to={`/${category.slug}`}>

                                                            {category.name}


                                                            {
    hasSub &&
    <KeyboardArrowDownIcon className="dropdown-icon" />
}


                                                        </Link>



                                                        {
                                                            hasSub &&

                                                            <ul

                                                                className={
                                                                    activeDropdown === index
                                                                        ?
                                                                        "dropdown active"
                                                                        :
                                                                        "dropdown"
                                                                }

                                                            >


                                                                {
                                                                    category.subcategories.map(sub => (

                                                                        <li key={sub._id}>


                                                                            <Link

                                                                                to={`/${category.slug}/${sub.slug}`}

                                                                            >

                                                                                {sub.name}

                                                                            </Link>


                                                                        </li>

                                                                    ))

                                                                }


                                                            </ul>


                                                        }



                                                    </li>

                                                )


                                            })

                                        }



                                        <li>

                                            <Link to="/contact">
                                                Contact
                                            </Link>

                                        </li>


                                        <li>

                                            <Link to="/about">
                                                About
                                            </Link>

                                        </li>



                                        <li>


                                            <IconButton
                                                onClick={() => setSearchOpen(true)}
                                            >

                                                <SearchIcon />

                                            </IconButton>


                                        </li>


                                    </ul>

                            }



                        </div>







                        {/* MOBILE ACTION */}

                        <div className="mobile-actions d-md-none">


                            <IconButton

                                onClick={() => setSearchOpen(!searchOpen)}

                            >

                                {

                                    searchOpen
                                        ?
                                        <CloseIcon />
                                        :
                                        <SearchIcon />

                                }


                            </IconButton>





                            <CartIcon cartItems={cartItems} />



                        </div>





                        {/* DESKTOP CART */}

                        <div className="desktop-cart d-none d-md-block">


                            <CartIcon cartItems={cartItems} />


                        </div>




                    </div>





                    {/* MOBILE SEARCH */}

                    {

                        searchOpen &&

                        <div className="mobile-search d-md-none">

                            <SearchBar width="100%" />

                        </div>

                    }



                </div>

            </div>






            {/* MOBILE DRAWER */}


            <Drawer

                anchor="left"

                open={drawerOpen}

                onClose={() => setDrawerOpen(false)}

            >


                <Box className="mobile-menu">


                    <div className="mobile-header">


                        <img

                            src={Logo}

                            className="mobile-logo"

                        />


                        <IconButton
                            onClick={() => setDrawerOpen(false)}
                        >

                            <CloseIcon />

                        </IconButton>


                    </div>





                    <List>


                        {
                            categories.map((category, index) => (


                                <React.Fragment key={category._id}>


                                    <ListItemButton

                                        onClick={() => setOpenParent(
                                            openParent === index ? null : index
                                        )}

                                    >


                                        <ListItemText

                                            primary={category.name}

                                        />


                                        {
                                            category.subcategories?.length > 0 &&

                                            (
                                                openParent === index
                                                    ?
                                                    <ExpandLess />
                                                    :
                                                    <ExpandMore />

                                            )

                                        }


                                    </ListItemButton>





                                    <Collapse

                                        in={openParent === index}

                                    >


                                        <List>


                                            {

                                                category.subcategories?.map(sub => (


                                                    <ListItemButton

                                                        key={sub._id}

                                                        component={Link}

                                                        to={`/${category.slug}/${sub.slug}`}

                                                        sx={{ pl: 5 }}

                                                        onClick={() => setDrawerOpen(false)}

                                                    >


                                                        <ListItemText

                                                            primary={sub.name}

                                                        />


                                                    </ListItemButton>


                                                ))


                                            }



                                        </List>


                                    </Collapse>



                                </React.Fragment>


                            ))


                        }




                        <ListItemButton component={Link} to="/contact">

                            <ListItemText primary="Contact Us" />

                        </ListItemButton>



                        <ListItemButton component={Link} to="/about">

                            <ListItemText primary="About Us" />

                        </ListItemButton>



                    </List>


                </Box>


            </Drawer>



        </header>

    )

};





const CartIcon = ({ cartItems }) => (


    <Link

        to="/cart"

        className="cart-wrapper"

    >


        <ShoppingBagIcon />


        {

            cartItems.length > 0 &&

            <span className="cart-count">

                {cartItems.length}

            </span>

        }


    </Link>


);



export default Header;